import { userConstants } from "../../constant";

const initialState = {
  appliedCoupon: null,
};

export function coupon(state = initialState, action) {
  switch (action.type) {
    case userConstants.COUPON_APPLIED:
      return {
        ...state,
        appliedCoupon: action.coupon,
      };
    case userConstants.COUPON_REMOVED:
      return {
        ...state,
        appliedCoupon: null,
      };
    default:
      return state;
  }
}
